module.exports = __webpack_public_path__ + "static/media/desktopScreenshot09.07bef9b6.jpg";